import React, {Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {translate} from "react-i18next";
import {compose} from "redux";
import {Form, Field} from 'react-final-form';

import SubmitButton from '../common/SubmitButton';
import Alerts from "../common/Alerts";
import Translation from "../common/Translation";
import CancelButton from "../common/CancelButton";
import Input from "../common/Input";
import LoadingIndicator from "../common/LoadingIndicator";

import { chargingCodeDetailPropTypes } from "../../common/propTypes";

class ChargingCodeDetail extends Component {
  constructor(props) {
    super(props);
    
    this.state = { loading: false };
    this.translatedFormValidation = this.translatedFormValidation.bind(this);
  }

  translatedFormValidation(values) {
    const { t } = this.props;
    const errors = {};

    if (!values.code) {
      errors.code = t('CodeIsRequired');      
    }

    if(values.code.length > 5) {
        errors.code = t('CodeMaxLength') + 5;      
    }

    if(values.name.length > 80) {
        errors.name = t('NameMaxLength') + 80;      
    }

    return errors;
  }

  render() {
    const {initialValues, headerText, onCancel} = this.props;

    return (
      <div>
        <div className="content-header">
          <h1>{headerText}</h1>
        </div>
        <div className="content-wrapper">
          <Alerts/>
          <div className="panel card col-xs-12 col-sm-6">
            <Form
              validate={this.translatedFormValidation}
              onSubmit={this.props.onSubmit}
              initialValues={initialValues}
              render={({handleSubmit, reset, submitting, pristine, values, valid, form}) => (

                <form className="k-form" onSubmit={handleSubmit}>
                  {this.state.loading && <LoadingIndicator/>}

                  <label className="k-form-field" htmlFor="code">
                    <span><Translation tKey="Code"/></span>
                    <Field name="code"
                           component={Input}
                    />
                  </label>
                  <label className="k-form-field" htmlFor="name">
                    <span><Translation tKey="Name"/></span>
                    <Field name="name"
                           component={Input}
                    />
                  </label>

                  <div className="footer">
                    <SubmitButton loading={submitting}><Translation tKey="Save"/></SubmitButton>
                    <CancelButton onClick={onCancel}><Translation tKey="Cancel"/></CancelButton>
                  </div>
                </form>
              )}/>
          </div>
        </div>
      </div>
    );
  }
}

ChargingCodeDetail.propTypes = {
  t: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  initialValues: chargingCodeDetailPropTypes.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,  
};

const mapStateToProps = (state) => {
  return {
    lang: state.app.lang,    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //fetchNewsPages: bindActionCreators(fetchNewsPages, dispatch),
    //fetchServices: bindActionCreators(fetchServices, dispatch),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate('common'))(ChargingCodeDetail);
